var map = {
	"./lang-icon-print.svg": 5670,
	"./lang-icon.svg": 2044,
	"./map-growth-green-small-horiz-cmyk.svg": 8091,
	"./math-icon-print.svg": 4663,
	"./math-icon.svg": 7684,
	"./read-icon-print.svg": 4805,
	"./read-icon.svg": 3214,
	"./scie-icon-print.svg": 7608,
	"./scie-icon.svg": 3527,
	"./soci-icon-print.svg": 5608,
	"./soci-icon.svg": 6784,
	"./spanish-read-icon-print.svg": 2769,
	"./spanish-read-icon.svg": 3832
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7275;